"use client";
import { FC } from "react";
import { ButtonProps } from "./ButtonProps";
import { CircularProgress, Toolbar } from "@mui/material";
import { AddIcon } from "assets";
import { CustomTooltip } from "components";

const AddButton: FC<ButtonProps> = ({
  children,
  type,
  className,
  onClick,
  label,
  loading,
  tooltip
}) => {

  return (
    <>
    <CustomTooltip title={tooltip} placement="bottom" >
    <button
      onClick={onClick}
      type={type}
      disabled={loading}
      className={`bg-primary-500 text-white font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-primary-900 hover:shadow-lg duration-300 ease-in-out transform ${className}`}
    >
      <span className="flex items-center space-x-2 justify-center text-xs font-semibold">
        {loading ? (
          <>
            <CircularProgress size={20} thickness={5} className="text-white" />
            Adding...
          </>
        ) : (
          <div className="flex items-center gap-1">
            <AddIcon/>
            {label} {children || ""}
          </div>
        )}
      </span>
    </button>
    </CustomTooltip>
    </>
  );
};

export default AddButton;
